import { Attachment } from '../../../types';
import { TRootState } from '../reducers';
import { IAttachesState } from '../reducers/types';

export const selectAttaches = (state: TRootState): IAttachesState => {
  return state.attaches;
};

export const selectAttachedFiles = (state: TRootState): Attachment[] => {
  return selectAttaches(state).attachments;
};

export const selectAttachedIsLoading = (state: TRootState): boolean => {
  return selectAttaches(state).isLoading;
};
